import React from "react";
import SquaberIcon from "../../../../landingPage/pages/Notifications/assets/squaber.svg";
import withTranslations from "../../../../../../hocs/withTranslations";
import { compose } from "redux";
import FromDateBox from "../FromDateBox/FromDateBox";
import { UrlProvider } from "../../../../../../api/UrlProvider";
import ChevronRight from "./assets/chevron-right.svg";
import withUserData from "../../../../../../hocs/withUserData";
import { showModal } from "../../../../../../lib/react-redux-modal-provider";
import SquaberLink from "../../../SquaberLink";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import classNames from "classnames";
import { useHistory } from "react-router";

const StockAnalysisButton = ({
  translate,
  analysisId,
  analysisDate,
  locale,
  permissions,
  hasPermission
}) => {
  const isDesktop = useIsDesktop();
  const history = useHistory();

  return (
    <div
      className={classNames(
        "flex bg-yellow-3 rounded-1 align-center cursor-pointer",
        {
          "py-2 px-3": isDesktop,
          "py-1 px-2.5": !isDesktop
        }
      )}
      onClick={event => {
        if (hasPermission(permissions)) {
          event.preventDefault();
          history.push(
            UrlProvider.getLocalizedUrl(locale, "fe.singleAnalysisPage", {
              locale,
              id: analysisId
            })
          );
          return;
        }

        showModal("PremiumModal", {
          skipShowIfAlreadyVisible: true,
          permissions
        });
      }}
    >
      <div
        className={classNames("flex flex-1", {
          "flex-row gap-4 align-center": isDesktop,
          "flex-col gap": !isDesktop
        })}
      >
        {isDesktop ? <img src={SquaberIcon} alt="squaber" height={32} /> : null}
        <strong
          className={classNames("font-semibold text-black line-height-130", {
            "text-base": isDesktop,
            "text-xs": !isDesktop
          })}
        >
          {translate("Read newest stock analysis")}
        </strong>
        <FromDateBox date={analysisDate} />
      </div>
      <SquaberLink
        to={UrlProvider.getLocalizedUrl(locale, "fe.singleAnalysisPage", {
          locale,
          id: analysisId
        })}
        className={"flex gap-2 align-center no-underline ml-3"}
        onClick={event => {
          if (hasPermission(permissions)) {
            return;
          }

          event.preventDefault();
          showModal("PremiumModal", {
            skipShowIfAlreadyVisible: true,
            permissions
          });
        }}
      >
        {isDesktop ? (
          <span className={"text-base font-semibold line-height-100"}>
            {translate("See")}
          </span>
        ) : null}
        <img
          src={ChevronRight}
          alt={""}
          width={20}
          height={20}
          className={"shrink-0"}
        />
      </SquaberLink>
    </div>
  );
};

export default compose(withTranslations, withUserData)(StockAnalysisButton);
